import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {GameEventComponent}  from './gameevent.component'
import {MeetingEventComponent}  from './meeting.event.component'

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'gameevent/:id',  component    :GameEventComponent },
      { path: 'meeting/:id',  component    :MeetingEventComponent }

    ])
  ]
})
export class GameEventRoutingModule { }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/gameevent.routing.ts